var store = require('../internals/shared')('wks');

var uid = require('../internals/uid');

var Symbol = require('../internals/global').Symbol;

var NATIVE_SYMBOL = require('../internals/native-symbol');

module.exports = function (name) {
  return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name] || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};